/**
 * @file skeleton.tsx
 * @description Loading placeholder с soft pulse-анимацией (phase08.5).
 */

import * as React from "react";

import { cn } from "@/lib/utils";

export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "animate-pulse rounded-md bg-surface-low",
        className,
      )}
      {...props}
    />
  );
}
